const numbersSpacesAndOptionalStartingPlusOnlyRegex = /^\+?[\d ]+$/;
const lettersAndSpacesOnlyRegex = /^[a-zA-Z\s]*$/;
const lettersSpacesHyphensApostrophesRegex = /^[a-zA-Z\s'-]*$/;
// const disallowedCharactersRegex = /^[\\^&<>"']*$/;
const disallowedCharactersRegex = /^[\\^&<>"]*$/; /* apostrophe removed */

const whitespaceRegex = /\s+/g;
const consecutiveWhitespaceRegex = /[\t\r ]{2,}/;

const ampersandLiteral = /&/g;
const lessThanLiteral = /</g;
const greaterThanLiteral = />/g;
const doubleQuoteLiteral = /"/g;
const singleQuoteLiteral = /'/g;

export {
  lettersAndSpacesOnlyRegex,
  lettersSpacesHyphensApostrophesRegex,
  numbersSpacesAndOptionalStartingPlusOnlyRegex,
  disallowedCharactersRegex,
  consecutiveWhitespaceRegex,
  whitespaceRegex,
  ampersandLiteral,
  lessThanLiteral,
  greaterThanLiteral,
  doubleQuoteLiteral,
  singleQuoteLiteral,
}